import { Modal } from "../../shared/components/Modal"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"
import RowContainer from "../../shared/components/Layout/RowContainer"
import ColumnContainer from "../../shared/components/Layout/ColumnContainer"
import Icon from "../../shared/components/Icon"

export interface WarningModalProps {
  isOpen: boolean
  onConfirm: () => void
  confirmLoading?: boolean
  onCancel: () => void
  onSecondary?: () => void
  text?: {
    title?: string
    confirmButton?: string
    cancelButton?: string
    secondaryButton?: string
    dialogAriaLabel?: string
  }
  children?: React.ReactNode
  usePrimaryButtonType?: boolean
  hideIconAndTitle?: boolean
  hideCancelButton?: boolean
}

export const WarningModal: React.FC<WarningModalProps> = ({
  isOpen,
  onConfirm,
  confirmLoading = false,
  onCancel,
  onSecondary,
  text,
  children,
  usePrimaryButtonType,
  hideIconAndTitle,
  hideCancelButton = false,
}) => {
  const { cms: cmsContent } = useCMSReady(["common"])
  const commonText = cmsContent.common
  const columnStyleOverrides = !!hideIconAndTitle
    ? "space-y-[0px]"
    : "space-y-[8px]"
  return (
    <Modal
      isOpen={isOpen}
      onSubmit={onConfirm}
      submitLoading={confirmLoading}
      onClose={onCancel}
      onCancel={hideCancelButton ? undefined : onCancel}
      onSecondary={onSecondary}
      panelStyleOverrides="pl-[24px] pr-[14px] pt-[14px] pb-[24px] w-[448px]"
      cancelButtonStyleOverrides="text-s min-w-[104px]"
      submitButtonRootStyleOverrides={`rounded-lg ml-2 text-white bg-red-700 hover:bg-red-800 min-w-[104px]`}
      submitButtonType={!!usePrimaryButtonType ? "primary" : "alert"}
      justifyButtons="justify-end space-x-5"
      text={{
        cancelButton: text?.cancelButton || commonText?.cancel,
        submitButton: text?.confirmButton || commonText?.continue,
        title: "",
        secondaryButton: text?.secondaryButton,
        dialogAriaLabel: text?.dialogAriaLabel,
      }}
      titleStyleOverrides={!!hideIconAndTitle ? "h-[30px]" : "h-[10px]"}
    >
      <RowContainer styleOverrides="space-x-0 gap-[0px]">
        {!!hideIconAndTitle ? (
          <ColumnContainer>
            <div className="w-[10px]" />
          </ColumnContainer>
        ) : (
          <ColumnContainer>
            <div className="w-[64px]">
              <Icon iconType="warning" />
            </div>
          </ColumnContainer>
        )}
        <ColumnContainer styleOverrides={columnStyleOverrides}>
          <RowContainer styleOverrides="items-center">
            <h2 id="warning-modal-title" className="text-xl font-medium m-0">
              {!!hideIconAndTitle
                ? ""
                : text?.title || commonText?.unsavedChangesTitle}
            </h2>
          </RowContainer>
          <RowContainer>
            <p
              className="m-0 text-gray-700"
              role="alert"
              aria-labelledby="warning-modal-title"
            >
              {children || commonText?.unsavedChangesMessage}
            </p>
          </RowContainer>
        </ColumnContainer>
      </RowContainer>
    </Modal>
  )
}
